/**
 * Utility functions for formatting addresses.
 */

/**
 * Formats an address from its components.
 * If streetAddress1 is provided, formats as: "streetAddress1, city state zipCode"
 * Otherwise, formats as: "city state zipCode" or "state zipCode" or "zipCode"
 *
 * @param streetAddress1 - The street address (optional)
 * @param city - The city (optional)
 * @param state - The state (optional)
 * @param zipCode - The zip code (optional)
 * @returns Formatted address string
 *
 * @example
 * formatAddress('123 Main St', 'San Francisco', 'CA', '94102') // Returns "123 Main St, San Francisco CA 94102"
 * formatAddress(null, 'San Francisco', 'CA', '94102') // Returns "San Francisco CA 94102"
 * formatAddress(null, null, 'CA', '94102') // Returns "CA 94102"
 */
export const formatAddress = (
  streetAddress1?: string | null,
  city?: string | null,
  state?: string | null,
  zipCode?: string | null,
): string => {
  let formattedAddress = '';
  const hasCity = city?.trim() ?? false;
  const hasState = state?.trim() ?? false;
  const hasZipCode = zipCode?.trim() ?? false;

  if (streetAddress1?.trim()) {
    formattedAddress += streetAddress1.trim();

    if (hasCity) {
      formattedAddress += `, ${city!.trim()}`;
    }

    if (hasState) {
      formattedAddress += ` ${state!.trim()}`;
    }

    if (hasZipCode) {
      formattedAddress += ` ${zipCode!.trim()}`;
    }
  } else if (hasCity) {
    formattedAddress = city!.trim();

    if (hasState) {
      formattedAddress += ` ${state!.trim()}`;
    }

    if (hasZipCode) {
      formattedAddress += ` ${zipCode!.trim()}`;
    }
  } else if (hasState) {
    formattedAddress = state!.trim();

    if (hasZipCode) {
      formattedAddress += ` ${zipCode!.trim()}`;
    }
  } else if (hasZipCode) {
    formattedAddress = zipCode!.trim();
  }

  return formattedAddress;
};
